import axios from 'axios';


export default axios.create({
    baseURL: `https://localhost:44353/api/`,
//baseURL: `https://deklaracje-odpady-api.um.wroc.pl/api/`,
});